﻿export class ApiResponse {
    statusCode: any;
    reasonPhrase: string;
    isSuccess: boolean;
    data: any;
    message: string;

    constructor() {
        this.statusCode = 0;
        this.reasonPhrase = '';
        this.isSuccess = false;
        this.data = {};
        this.message = '';
    }
}


/** WEBPACK FOOTER **
 ** ./app/models/api-response.ts
 **/